<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Feed"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedFeeds"
      :columns="columns"
      :total-rows="totalFeeds"
      :get-edit-url="getEditUrl"
    >
      <template #actions="{ row }">
        <q-td class="q-pa-none text-center">
          <q-btn
            size="sm"
            color="primary"
            label="Edit"
            @click="$router.push(getEditUrl(row))"
            class="q-mr-sm"
          />
          <q-btn
            size="sm"
            :color="row.is_active ? 'negative' : 'positive'"
            :label="row.is_active ? 'Deactivate' : 'Reactivate'"
            @click="toggleActive(row)"
          />
        </q-td>
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'FeedTable',
  components: {
    BaseTable
  },
  data() {
    return {
      feeds: [],
      totalFeeds: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedFeeds() {
      return this.feeds.map(feed => ({
        ...feed,
        add_date: new Date(feed.add_date).toLocaleDateString(),
        edit_date: new Date(feed.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchFeeds();
  },
  methods: {
    fetchFeeds() {
      axios
        .get('/api/v1/feed/feeds/', { params: { show_inactive: true } })
        .then(response => {
          this.feeds = response.data;
          this.totalFeeds = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching feeds:', error);
        });
    },
    onAdd() {
      this.$router.push('/feed/add');
    },
    getEditUrl(row) {
      return `/feed/edit/${row.id}/`;
    },
    toggleActive(row) {
      axios
        .patch(`/api/v1/feed/feeds/${row.id}/`, { is_active: !row.is_active })
        .then(() => {
          this.$q.notify({
            color: 'green',
            message: `Feed ${row.is_active ? 'deactivated' : 'reactivated'}.`,
            icon: 'check'
          });
          this.fetchFeeds();
        })
        .catch(error => {
          console.error('Error updating feed active state:', error);
          this.$q.notify({
            color: 'red',
            message: 'Failed to update feed status.',
            icon: 'error'
          });
        });
    }
  },
  watch: {
    feeds() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the FeedTable here */
</style>
